<template>
  <div>

        <div style="display: flex; justify-content: space-between; margin-bottom: 20px;">
          <div class="glow-effect" style="width: 22%; height: 100px; border: 1px solid #0fb2f6;" >
            <div style="font-size: 25px;color: #18dec5; font-weight: 900; margin: 15px 0px 10px 0px;">{{ TotalAmountOfCourseCancellations }}</div>
            <div class="clickable-text">新增客资数 = 新添加客户数</div>
          </div>
          <div class="glow-effect" style="width: 22%;height: 100px; border: 1px solid #0fb2f6;" >
            <div style="font-size: 25px;color: #18dec5; font-weight: 900; margin: 15px 0px 10px 0px;">{{ TotalCourseHoursToBeCancelled }}</div>
            <div class="clickable-text">新增成交数 = 新添加成交客户数(成交时间计算)</div>
          </div>
          <div class="glow-effect" style="width: 22%;height: 100px; border: 1px solid #0fb2f6;" >
            <div style="font-size: 25px;color: #18dec5; font-weight: 900; margin: 15px 0px 10px 0px;">{{ TodaysTotalAmountOfNewlyAddedClassExpenses }}</div>
            <div class="clickable-text">新增成交金额 = 列表总金额总和</div>
          </div>
          <div class="glow-effect" style="width: 22%;height: 100px; border: 1px solid #0fb2f6;">
            <div style="font-size: 25px;color: #18dec5; font-weight: 900; margin: 15px 0px 10px 0px;">{{ TodaysNewlyAddedClassHours }}</div>
            <div class="clickable-text">新增续费 = 列表续费总和</div>
          </div>
        </div>

        <div style="margin-bottom: 20px; display: flex; margin-top: 30px;">
          <div style="display: flex;">
            <div style="width: 80px;padding-top: 10px;">时间范围:</div>
            <el-date-picker v-model="createTime" type="monthrange" range-separator="至"  start-placeholder="开始日期" end-placeholder="结束日期" clearable>
            </el-date-picker>
          </div>
          <div style="display: flex;margin-left: 20px;">
            <div style="width: 80px;padding-top: 10px;margin-right: 10px;">客资来源:</div>
            <el-select placeholder="全部客资来源" v-model="input2" style="width: 100%" clearable filterable>
              <el-option v-for="item in optionList2" :key="item.sourcepeopleId" :label="item.sourcepeopleName" :value="item.sourcepeopleId"></el-option>
            </el-select>
          </div>
        </div>
        <div style="margin-bottom: 20px;text-align: end;">
          <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="handleOnekeyCourseConsumption">查询</el-button>
        </div>


        <el-table v-loading="isLoading" :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataListactualCourseConsumptionStatistics" border height="700">
            <el-table-column prop="customerWx" header-align="center"  label="微信号" ></el-table-column>
            <el-table-column prop="customerStudent" header-align="center"  label="学生名" ></el-table-column>
            <el-table-column prop="customerSourcepeopleName" header-align="center"  label="客资来源" ></el-table-column>
            <el-table-column prop="sumMoney" header-align="center"  label="总金额" ></el-table-column>
            <el-table-column prop="diagnoseMoneySum" header-align="center"  label="新增诊断费" ></el-table-column>
            <el-table-column prop="finalPaymentSum" header-align="center"  label="新增尾款" ></el-table-column>
            <el-table-column prop="renewSum" header-align="center"  label="新增续费" ></el-table-column>
            <el-table-column header-align="center" label="操作" width="150px">
              <template slot-scope="scope">
                <el-button type="text" @click="details_s(scope.row)">详情</el-button>
              </template>
            </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChangealCourseConsumptionStatistics" @current-change="handleCurrentChangealCourseConsumptionStatistics"
          :current-page="requestParametersalCourseConsumptionStatistics.pageNum" :page-size="requestParametersalCourseConsumptionStatistics.pageSize"
          layout="prev, pager, next,sizes, jumper" :total="requestParametersalCourseConsumptionStatistics.total">
        </el-pagination>

        <OrderDetails ref="OrderDetail" v-if="orderDetailComponentsShow"  @handleEventColes="handleEventColes"></OrderDetails>

  </div>
</template>

<script>
import OrderDetails from './OrderDetails.vue'
import axios from 'axios'
import apiBaseUrl from '../../config/api'
export default {
  components:{
    OrderDetails,
  },
  props:{
    tongjiBoj:{
      default: {
        eventObj: null,
        createTime: [],
      },
      type: Object
    }
  },
  name: "tongji",
  data() {
    return {

      isLoading: false,

      orderDetailComponentsShow: false,
      orderFormComponentsID:'',
      orderFormComponentsType:'',

      createTime:[],
      optionList2:[],
      input2: '',

      requestParametersalCourseConsumptionStatistics:{
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },

      dataListactualCourseConsumptionStatistics:[],

      TotalAmountOfCourseCancellations: 0,
      TotalCourseHoursToBeCancelled: 0,
      TodaysTotalAmountOfNewlyAddedClassExpenses: 0,
      TodaysNewlyAddedClassHours: 0,


    }
  },
  mounted() {

    axios.get(`${apiBaseUrl}/customerinformation/sourcepeoplelist`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(response => {
        this.optionList2 = response.data.data.list
    })

    // this.createTime[0] = this.tongjiBoj.createTime
    // this.createTime[1] = this.tongjiBoj.createTime
    this.$set(this.createTime,0, this.tongjiBoj.createTime)
    this.$set(this.createTime,1, this.tongjiBoj.createTime)

    this.input2 = this.tongjiBoj.eventObj.id

    this.getclient_resourcefindCollect()
    this.getdataListactualCourseConsumptionStatistics()

  },
  methods: {

    details_s(row){
      this.orderDetailComponentsShow = true
      // this.orderFormComponentsID = row.customerId
      // this.orderFormComponentsType = '详情'

      this.$nextTick(() => {
          this.$refs.OrderDetail.init(row.customerId)
      })
    },

    handleOnekeyCourseConsumption(){
      this.isLoading = true
      setTimeout(() => {
        this.getclient_resourcefindCollect()
        this.getdataListactualCourseConsumptionStatistics()
      }, 1000)
    },


    handleEventColes(event){
      this.orderDetailComponentsShow = event
    },

    formattedYearMonth(value) {
      let date = new Date(value)
      let formattedDate = date.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit' })
      let valuesTime = formattedDate.split('/')
      return valuesTime[1] + '-' + valuesTime[0]
    },

    getclient_resourcefindCollect(){
      let data = {
        startDate: (this.createTime && this.createTime.length > 0) ? this.formattedYearMonth(this.createTime[0]) + '-01' + ' 00:00:00' : null,
        endDate: (this.createTime && this.createTime.length > 0) ? this.formattedYearMonth(this.createTime[1]) + '-31' + ' 00:00:00': null,
        sourcepeopleId: this.input2 ? this.input2 : null,
      }
      axios.post(`${apiBaseUrl}/client_resource/findCollect`, data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },}).then(res => {
        if(res.data.code == 200){
            this.TotalAmountOfCourseCancellations = res.data.data.clientResourceNumber
            this.TotalCourseHoursToBeCancelled = res.data.data.bargainNumber
            this.TodaysTotalAmountOfNewlyAddedClassExpenses = res.data.data.bargainMoney
            this.TodaysNewlyAddedClassHours = res.data.data.renewMoney
        }else{
            this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$message.error(err)
      })
    },

    getdataListactualCourseConsumptionStatistics(){
      let data = {
        pageNum: this.requestParametersalCourseConsumptionStatistics.pageNum ? this.requestParametersalCourseConsumptionStatistics.pageNum : null,
        pageSize: this.requestParametersalCourseConsumptionStatistics.pageSize ? this.requestParametersalCourseConsumptionStatistics.pageSize : null,
        startDate: (this.createTime && this.createTime.length > 0) ? this.formattedYearMonth(this.createTime[0]) + '-01' + ' 00:00:00': null,
        endDate: (this.createTime && this.createTime.length > 0) ? this.formattedYearMonth(this.createTime[1]) + '-31' + ' 00:00:00': null,
        sourcepeopleId: this.input2 ? this.input2 : null,
      }
      axios.post(`${apiBaseUrl}/client_resource/findStatisticsPage`, data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },}).then(res => {
        if(res.data.code == 200){
            this.isLoading = false
            if(res.data.data.records && res.data.data.records.length > 0){
                this.dataListactualCourseConsumptionStatistics = res.data.data.records
            }else{
              this.dataListactualCourseConsumptionStatistics = []
            }

            this.requestParametersalCourseConsumptionStatistics.total = res.data.data.total
            this.requestParametersalCourseConsumptionStatistics.pageNum = res.data.data.current
            this.requestParametersalCourseConsumptionStatistics.pageSize = res.data.data.size

            this.$message({ message: res.data.message,  type: 'success'  })
        }else{
            this.isLoading = false
            this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$message.error(err)
        this.isLoading = false
      })
    },

    handleSizeChangealCourseConsumptionStatistics(Size){
      this.requestParametersalCourseConsumptionStatistics.pageSize = Size
      this.getdataListactualCourseConsumptionStatistics()
    },

    handleCurrentChangealCourseConsumptionStatistics(Current){
      this.requestParametersalCourseConsumptionStatistics.pageNum = Current
      this.getdataListactualCourseConsumptionStatistics()
    },

  },
  watch: {

  },

}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/statistics/tongji.vue